export default __webpack_public_path__ + "static/media/user-dil-red.ba559542.svg";